import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Tooltip } from "@mui/material";

import Styles from "./SideNavBar.module.css";
import sidebarCompanyIcon from "../../assets/images/companIcon.svg";
import panelClose from "../../assets/images/panelClose.svg";

import { ReactComponent as UserRoundPen } from "../../assets/images/UserRoundPen.svg";
import { ReactComponent as Bess } from "../../assets/images/bessIcon.svg";
import { ReactComponent as BessOrange } from "../../assets/images/BessOrange.svg";
import { ReactComponent as ArcIcon } from "../../assets/images/arcIcon.svg";
import { ReactComponent as LccIcon } from "../../assets/images/lccIcon.svg";
import { ReactComponent as BuySell } from "../../assets/images/buySellGrey.svg";
import { ReactComponent as BuySellOrange } from "../../assets/images/buySellOrnage.svg";
import { ReactComponent as DiscomIconGrey } from "../../assets/images/BankingGrey.svg";
import { ReactComponent as BankingOrange } from "../../assets/images/BankingOrange.svg";
import { ReactComponent as ConsumerGrey } from "../../assets/images/consumerGrey.svg";
import { ReactComponent as CompanyAdminIconGrey } from "../../assets/images/compAdminGrey.svg";
import { ReactComponent as CompanyAdminIconOrange } from "../../assets/images/compAdminOrangesvg.svg";
import { ReactComponent as ConsumerOrange } from "../../assets/images/ConsumerOrange.svg";
import { ReactComponent as GeneratorOrange } from "../../assets/images/GeneratorOrange.svg";
import { ReactComponent as BankingLedgerOrange } from "../../assets/images/BankingLedgerOrange.svg";
import { ReactComponent as BankingLedgerGrey } from "../../assets/images/BankingLedgerGrey.svg";
import { ReactComponent as SearchBankingOrange } from "../../assets/images/SeaBankOrange.svg";
import { ReactComponent as SearchBankingGrey } from "../../assets/images/SeaBankGrey.svg";
import { ReactComponent as ProfileOrange } from "../../assets/images/profileOrange.svg";
import { ReactComponent as EscrowOrange } from "../../assets/images/escrowOrange.svg";
import { ReactComponent as EscrowGrey } from "../../assets/images/escrowGrey.svg";
import { ReactComponent as ArchiveOrange } from "../../assets/images/archiveOrange.svg";
import { ReactComponent as LccOrange } from "../../assets/images/LCCorange.svg";
import { ReactComponent as LccGrey } from "../../assets/images/LCCgrey.svg";
import { ReactComponent as RfqGrey } from "../../assets/images/rfqGrey.svg";
import { ReactComponent as RfqOrange } from "../../assets/images/rfqOrange.svg";
import { ReactComponent as ReverseAucGrey } from "../../assets/images/reverseAucGrey.svg";
import { ReactComponent as ReverseAucOrange } from "../../assets/images/reverseAucOrange.svg";
import { ReactComponent as BilateralGrey } from "../../assets/images/bilateralGrey.svg";
import { ReactComponent as BilateralOrange } from "../../assets/images/bilateralAnotherOrange.svg";
import { ReactComponent as VppaGrey } from "../../assets/images/vpGrey.svg";
import { ReactComponent as VppaOrange } from "../../assets/images/vpOrange.svg";
import { ReactComponent as RecGrey } from "../../assets/images/recGrey.svg";
import { ReactComponent as RecOrange } from "../../assets/images/recOrange.svg";
import { ReactComponent as GenIconGrey } from "../../assets/images/genIconGrey.svg";
import { ReactComponent as LogoutIcon } from "../../assets/images/logoutGrey.svg";
import { ReactComponent as LogoutIconHover } from "../../assets/images/logoutOrange.svg";
import RaDateCHange from "../Modals/RaDateChange/RaDateCHange";

import { loginSwitchService } from "../../Services/ApiCalling/Auth";
import { activeLoading } from "../../Redux/Slices/notificationSlice";
import { login, logout } from "../../Redux/Slices/authSlice";
import { ErrorMessage } from "../../commons/Toast/ErrorMessage";
import {
  emptyCounterPartyList,
  emptySelfList,
  fetchSelfCapacity,
  fetchSideBarList,
  setActiveListingId,
} from "../../Redux/Slices/CapacitySlice";
import { setActiveRegion } from "../../Redux/Slices/activeRegionSlice";
import { setActiveEntity } from "../../Redux/Slices/activeEntitySlice";
import { fetchUserPaymentConfig } from "../../Redux/Slices/platformSlice";

const getProducts = ({ user, state, mapingProduct }) => {
  const isQaOrStage =
    process.env.REACT_APP_ENV === "qa" || process.env.REACT_APP_ENV === "stage";

  const allProducts = [
    {
      user: "banking",
      name: "Banking",
      link: "/banking",
      Icon: DiscomIconGrey,
      HoverIcon: BankingOrange,
      productId: "1",
      firstChild: [
        {
          name: "Dashboard",
          link: "/banking",
          Icon: DiscomIconGrey,
          HoverIcon: BankingOrange,
        },
        // {
        //   name: "My Banking Ledger",
        //   link: "/banking_ledger",
        //   Icon: BankingLedgerGrey,
        //   HoverIcon: BankingLedgerOrange,
        // },
        {
          name: "Available Banking",
          link: "/banking_search",
          Icon: SearchBankingGrey,
          HoverIcon: SearchBankingOrange,
        },
        {
          view: process.env.REACT_APP_ENV === "qa",
          name: "Reconciliation",
          link: "/banking_reconciliation",
          Icon: SearchBankingGrey,
          HoverIcon: SearchBankingOrange,
        },
      ],
    },
    {
      user,
      name: user === "consumer" || user === "CONSUMER" ? "Buy" : "Sell",
      link: "/dashboard",
      Icon: BuySell,
      HoverIcon: BuySellOrange,
      productId: "2",
      firstChild: [
        {
          name: "Market Place",
          link: "/search_listing",
          Icon: SearchBankingGrey,
          HoverIcon: SearchBankingOrange,
        },

        {
          view: true,
          name: "Bilateral",
          link: "/dashboard",
          Icon: BilateralGrey,
          HoverIcon: BilateralOrange,
        },
        // {
        //   view: mapingProduct?.find((ele) => ele?.productName === "RFP_RFQ")
        //     ?.productId
        //     ? true
        //     : false,
        //   name: "RFP/RFQ",
        //   link:
        //     user === "consumer" || user === "CONSUMER"
        //       ? "/rfq?type=initiate"
        //       : "/rfq?type=place_bid",
        //   Icon: RfqGrey,
        //   HoverIcon: RfqOrange,
        // },
        // {
        //   view: mapingProduct?.find((ele) => ele?.productName === "RA")
        //     ?.productId
        //     ? true
        //     : false,
        //   name: "Reverse Auction",
        //   link:
        //     user === "consumer" || user === "CONSUMER"
        //       ? "/reverse_auction?type=initiate"
        //       : "/reverse_auction?type=place_bid",
        //   Icon: ReverseAucGrey,
        //   HoverIcon: ReverseAucOrange,
        // },
        // {
        //   view: mapingProduct?.find(
        //     (ele) => ele?.productName === "TRADE_CONNECT",
        //   )?.productId
        //     ? true
        //     : false,
        //   name: "TradeConnect",
        //   link:
        //     user === "consumer" || user === "CONSUMER"
        //       ? "/tradeconnect?type=initiate"
        //       : "/tradeconnect?type=place_bid",
        //   Icon: RfqGrey,
        //   HoverIcon: RfqOrange,
        //   children: [
        //     {
        //       name: "Initiate",
        //       link: "/tradeconnect?type=initiate",
        //       Icon: RfqGrey,
        //       HoverIcon: RfqOrange,
        //     },
        //     {
        //       name: "Place Bid",
        //       link: "/tradeconnect?type=place_bid",
        //       Icon: RfqGrey,
        //       HoverIcon: RfqOrange,
        //     },
        //   ],
        // },
        // {
        //   name: "BESS",
        //   link: "/bess",
        //   Icon: Bess,
        //   HoverIcon: BessOrange,
        //   productId: "3",
        //   firstChild: [],
        // },
        // {
        //   name: "REC",
        //   link: "/rec",
        //   Icon: RecGrey,
        //   HoverIcon: RecOrange,
        //   productId: "4",
        //   firstChild: [],
        // },
        // {
        //   name: "VPPA",
        //   link: "/vppa",
        //   Icon: VppaGrey,
        //   HoverIcon: VppaOrange,
        //   productId: "5",
        //   firstChild: [],
        // },
      ],
    },
  ];

  const filteredProducts = allProducts.map((product) => ({
    ...product,
    firstChild:
      product.firstChild?.filter((child) => child.view !== false) ?? [],
  }));

  if (user === "COMPANY_ADMIN") return [];
  return user === "BANKING"
    ? filteredProducts.filter((p) => p.productId === "1")
    : filteredProducts.filter((p) => p.productId !== "1");
};

const getProfileOptions = ({ user, state }) => {
  const isQa = process.env.REACT_APP_ENV === "qa";

  const allOptions = [
    ...(isQa
      ? [
          {
            name: "Contract Calculator",
            link: "/contract_calculator",
            Icon: UserRoundPen,
            HoverIcon: ProfileOrange,
            role: ["BANKING"],
          },
        ]
      : []),
    {
      name: "My Profile",
      link: "/my_profile",
      Icon: UserRoundPen,
      HoverIcon: ProfileOrange,
      role: ["CONSUMER", "GENERATOR", "BANKING"],
      view: true,
    },
    // {
    //   name: "Escrow",
    //   link: "/wallet",
    //   Icon: EscrowGrey,
    //   HoverIcon: EscrowOrange,
    //   role: ["CONSUMER", "GENERATOR"],
    //   view: true,
    // },
    // {
    //   name: "Archive",
    //   link: "/archive",
    //   Icon: ArcIcon,
    //   HoverIcon: ArchiveOrange,
    //   role: ["CONSUMER", "GENERATOR", "BANKING"],
    //   view: true,
    // },
    // {
    //   name: "Unified Ledger",
    //   link: "/unified_ledger",
    //   Icon: LccIcon,
    //   HoverIcon: LccOrange,
    //   role: ["CONSUMER", "GENERATOR"],
    //   view: true,
    // },
    // {
    //   name: "RA Date Change",
    //   link: "ra_date_change",
    //   Icon: LccIcon,
    //   HoverIcon: LccOrange,
    //   role: ["CONSUMER", "GENERATOR"],
    //   view:
    //     process.env.REACT_APP_ENV === "qa" ||
    //     process.env.REACT_APP_ENV === "stage",
    // },
  ];

  return allOptions.filter((opt) => opt.role.includes(user) && opt.view);
};

const getRedirectPath = (role) => {
  const paths = {
    SUPER_ADMIN: "/admin_dashboard",
    MAKER: "/admin_dashboard",
    CHECKER: "/admin_dashboard",
    ADMIN: "/admin_dashboard",
    ANALYST: "/analyst_dashboard",
    TRADER: "/trader_dashboard",
    BANKING: "/banking",
    COMPANY_ADMIN: "/admin_company_dashboard",
    CONSUMER: "/dashboard",
    GENERATOR: "/dashboard",
  };
  return paths[role] || "/dashboard";
};

const getRoleConfig = ({ name, consumers, generators, discoms }) => {
  const configs = {
    COMPANY_ADMIN: {
      name: "Company Admin",
      icon: CompanyAdminIconGrey,
      hoverIcon: CompanyAdminIconOrange,
      role: "COMPANY_ADMIN",
    },
    BANKING: {
      name: "Banking",
      list: discoms,
      icon: DiscomIconGrey,
      hoverIcon: BankingOrange,
      role: "BANKING",
    },
    CONSUMER: {
      name: "Buyer",
      list: consumers,
      icon: ConsumerGrey,
      hoverIcon: ConsumerOrange,
      role: "CONSUMER",
    },
    GENERATOR: {
      name: "Seller",
      list: generators,
      icon: GenIconGrey,
      hoverIcon: GeneratorOrange,
      role: "GENERATOR",
    },
  };
  return configs[name] || name;
};

const getEntityDetails = (item) => ({
  id: item.consumerId || item.generatorId || item.discomId,
  name: item.consumerName || item.generatorName || item.discomName,
});

const PRODUCT_ROUTES = [
  "/dashboard",
  "/rfq",
  "/reverse_auction",
  "/tradeconnect",
];

const SideNavBar = ({ navOpen, onNavSwitch }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const entity = useSelector((s) => s.persistedReducer?.user);
  const company = useSelector((s) => s.persistedReducer.company);
  const stateLabel = useSelector((s) => s.persistedReducer.company?.stateLabel);
  const activeUser = useSelector((s) => s.persistedReducer.user);
  const sideBarList = useSelector((s) => s.CapacitySlice.fetchSideBarList);

  const mapingData = useSelector((s) => s?.platformSlice?.userPaymentConfigs);

  const location = useLocation();

  const [activeHover, setActiveHover] = useState("");
  const [activeExpanded, setActiveExpanded] = useState(
    activeUser?.activeRole || "",
  );
  const [raChange, setRaChange] = useState(false);

  const [selectedSide, setSelectedSide] = useState("");

  const [hoverEntity, setHoverEntity] = useState("");
  const [flyoutPos, setFlyoutPos] = useState(null);
  const closeTimerRef = useRef(null);

  useEffect(() => {
    dispatch(fetchSideBarList());
  }, [dispatch]);

  useEffect(() => {
    if (PRODUCT_ROUTES.includes(location.pathname)) {
      sessionStorage.setItem("lastProductRoute", location.pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      entity &&
      entity.activeRole !== "COMPANY_ADMIN" &&
      entity.activeRole !== "BANKING"
    ) {
      dispatch(
        fetchUserPaymentConfig({
          role: entity?.activeRole,
          entityId: entity?.activeConsumerId || entity?.activeGeneratorId,
          companyId: company?.companyId,
        }),
      );
    }
  }, [dispatch, entity]);

  const ROLE_ORDER = ["COMPANY_ADMIN", "BANKING", "CONSUMER", "GENERATOR"];
  const roles = (() => {
    const availableRoles = new Set(sideBarList?.roles ?? []);
    return ROLE_ORDER.filter((role) => availableRoles.has(role)).map((role) =>
      getRoleConfig({
        name: role,
        generators: sideBarList.generators || [],
        consumers: sideBarList.consumers || [],
        discoms: sideBarList.discoms || [],
      }),
    );
  })();

  const assignedProducts = getProducts({
    user: activeUser?.activeRole,
    state: stateLabel,
    mapingProduct: mapingData,
  });

  const commonProfile = getProfileOptions({
    user: activeUser?.activeRole,
    state: stateLabel,
  });

  const handleSwitchUser = async ({ role, id, displayName }) => {
    const payload = {
      switchRole: role,
      switchCompanyId: null,
      switchConsumerId: role === "CONSUMER" ? id : null,
      switchGeneratorId: role === "GENERATOR" ? id : null,
      switchDiscomId: role === "BANKING" ? id : null,
    };

    dispatch(activeLoading(true));
    const res = await loginSwitchService(payload);

    if (res?.data?.code === 200) {
      const { data } = res.data;
      dispatch(setActiveListingId(null));
      dispatch(emptyCounterPartyList());
      dispatch(emptySelfList());
      dispatch(login(data));
      dispatch(setActiveRegion(data.activeUserRegionName || ""));
      localStorage.setItem("OTC_V2_TOKEN", data.token);
      dispatch(setActiveEntity(displayName || ""));
      navigate(getRedirectPath(data.activeRole));
      setTimeout(() => {
        dispatch(activeLoading(false));
        window.location.reload();
      }, 2000);
      if (data.activeRole !== "COMPANY_ADMIN") {
        dispatch(fetchSelfCapacity({ user: data.activeRole.toLowerCase() }));
      }
    } else {
      dispatch(activeLoading(false));
      ErrorMessage(res?.data?.error || "Switch failed");
    }
  };

  const activeEntity = roles
    .find((r) => r.role === activeUser?.activeRole)
    ?.list?.find((i) =>
      activeUser?.activeRole === "CONSUMER"
        ? i.consumerId === activeUser?.activeConsumerId
        : activeUser?.activeRole === "GENERATOR"
          ? i.generatorId === activeUser?.activeGeneratorId
          : i.discomId === activeUser?.activeDiscomId,
    );
  const handleEntityExp = (val) =>
    setActiveExpanded((prev) => (prev === val ? "" : val));

  const handlesetSelectedSide = (val) => {
    setSelectedSide(val);
  };

  const handlesetHoverEntity = (val) => {
    setHoverEntity(val);
  };

  const scheduleClose = () => {
    clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => {
      setSelectedSide("");
      setFlyoutPos(null);
    }, 200);
  };

  const cancelClose = () => {
    clearTimeout(closeTimerRef.current);
  };

  const handleOpenFlyout = (name, el) => {
    cancelClose();
    setSelectedSide(name);
    if (el) {
      const rect = el.getBoundingClientRect();
      setFlyoutPos({ top: rect.top, left: rect.right });
    }
  };

  const EntityList = ({ list, selectedSide }) => {
    return (
      <>
        {list?.map((ele) => {
          const activeEntityId =
            ele.role === "CONSUMER"
              ? activeEntity?.consumerId
              : ele.role === "GENERATOR"
                ? activeEntity?.generatorId
                : activeEntity?.discomId;

          const isActiveView =
            (selectedSide === "Buyer" && activeEntityId === ele?.consumerId) ||
            (selectedSide === "Seller" &&
              activeEntityId === ele?.generatorId) ||
            (selectedSide === "Banking" && activeEntityId === ele?.discomId) ||
            hoverEntity ===
              (ele?.consumerName || ele?.generatorName || ele?.discomName);
          return (
            <div
              key={ele?.consumerId || ele?.generatorId || ele?.discomId}
              className={Styles.entitySelfSelection}
              onMouseEnter={() =>
                handlesetHoverEntity(
                  ele?.consumerName || ele?.generatorName || ele?.discomName,
                )
              }
              onMouseLeave={() => handlesetHoverEntity("")}
              onClick={() =>
                handleSwitchUser({
                  role:
                    selectedSide === "Buyer"
                      ? "CONSUMER"
                      : selectedSide === "Seller"
                        ? "GENERATOR"
                        : "BANKING",
                  id: ele?.consumerId || ele?.generatorId || ele?.discomId,
                  displayName:
                    ele?.consumerName || ele?.generatorName || ele?.discomName,
                })
              }
            >
              <div
                className={
                  isActiveView
                    ? Styles.activeViewNotif
                    : Styles.inActiveViewNotif
                }
              />
              <Tooltip
                title={
                  ele?.consumerName || ele?.generatorName || ele?.discomName
                }
                arrow
                placement="right"
              >
                <div
                  className={isActiveView ? Styles.activeViewTextEntity : ""}
                >
                  {ele?.consumerName || ele?.generatorName || ele?.discomName}
                </div>
              </Tooltip>
            </div>
          );
        })}
      </>
    );
  };

  const EntityListMain = ({ role, ele }) => {
    const isCurrRole = activeUser?.activeRole === ele.role;
    const isExpanded = activeExpanded === ele.role;
    const isActive = isCurrRole || selectedSide === ele?.name || isExpanded;
    const Icon = isActive ? ele.hoverIcon : ele.icon;

    if (!navOpen) {
      return (
        <div
          className={`${Styles.collapsedItem} ${isCurrRole ? Styles.collapsedItemActive : ""}`}
          onMouseEnter={() => handlesetSelectedSide(ele.name)}
          onMouseLeave={() => handlesetSelectedSide("")}
          onClick={() =>
            ele.role === "COMPANY_ADMIN"
              ? handleSwitchUser({ role: ele.role })
              : onNavSwitch()
          }
        >
          <Icon style={{ height: "20px", width: "20px" }} />
          <span>{ele.name}</span>
        </div>
      );
    }

    return (
      <div
        className={`${Styles.entityListMain} ${isActive && Styles.activeRoleContainer}`}
        key={ele.role}
        onMouseEnter={(e) => handleOpenFlyout(ele.name, e.currentTarget)}
        onMouseLeave={scheduleClose}
        onClick={() =>
          ele.role === "COMPANY_ADMIN" && handleSwitchUser({ role: ele.role })
        }
        style={ele.role === "COMPANY_ADMIN" ? { cursor: "pointer" } : {}}
      >
        <div className={`${Styles.entityCollapsedConainter} `}>
          <div
            className={`${isActive ? Styles.activeViewNotif : Styles.inActiveViewNotif} `}
          />
          <Icon style={{ height: "16px", width: "16px" }} />
          <div
            className={`${Styles.collapseRoleName} ${isActive && Styles.activeRoleContainerText}`}
          >
            {ele.name}
          </div>
        </div>
        {ele?.list?.length > 0 && (
          <ArrowForwardIosIcon
            style={{
              fontSize: "10px",
              color: isActive ? "var(--primary-color-text)" : "#617499",
              rotate: selectedSide === ele?.name ? "180deg" : "0deg",
              transition: "rotate 0.3s ease-in-out",
            }}
          />
        )}
      </div>
    );
  };

  const stripQuery = (link) => (link || "").split("?")[0];

  const ProductListMain = ({ ele }) => {
    const fromBankingLedger = location.state?.fromBankingLedger === true;
    const isRouteActive =
      location.pathname === stripQuery(ele.link) ||
      ele.children?.some((c) => location.pathname === stripQuery(c.link)) ||
      (location.pathname === "/tender_active" &&
        sessionStorage.getItem("lastProductRoute") === stripQuery(ele.link)) ||
      (location.pathname === "/banking_active" &&
        stripQuery(ele.link) ===
          (fromBankingLedger ? "/banking_ledger" : "/banking"));
    const isHovered = selectedSide === ele.name;
    const isActive = isRouteActive || isHovered;
    const Icon = isActive ? ele.HoverIcon : ele.Icon;

    const handleClick = () => {
      handlesetSelectedSide("");
      if (ele.link === "ra_date_change") {
        setRaChange(true);
      } else {
        navigate(ele.link);
      }
    };

    if (!navOpen) {
      return (
        <div
          className={`${Styles.collapsedItem} ${isRouteActive ? Styles.collapsedItemActive : ""}`}
          onClick={handleClick}
        >
          <Icon style={{ height: "20px", width: "20px" }} />
          <span>{ele.name}</span>
        </div>
      );
    }

    return (
      <div
        className={`${Styles.entityListMain} ${isActive ? Styles.activeRoleContainer : ""}`}
        onMouseEnter={(e) => handleOpenFlyout(ele.name, e.currentTarget)}
        onMouseLeave={scheduleClose}
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className={Styles.entityCollapsedConainter}>
          <div
            className={
              isActive ? Styles.activeViewNotif : Styles.inActiveViewNotif
            }
          />
          <Icon style={{ height: "16px", width: "16px" }} />
          <div
            className={`${Styles.collapseRoleName} ${isActive ? Styles.activeRoleContainerText : ""}`}
          >
            {ele.name}
          </div>
        </div>

        {ele?.children?.length > 0 && (
          <ArrowForwardIosIcon
            style={{
              fontSize: "10px",
              color: isActive ? "var(--primary-color-text)" : "#617499",
            }}
          />
        )}
      </div>
    );
  };

  const ProfileListMain = ({ ele }) => {
    const isActive = !ele.direct && location.pathname === ele.link;
    const isHovered = activeHover === ele.name;
    const showActive = isActive || isHovered;
    const Icon = showActive ? ele.HoverIcon : ele.Icon;

    const handleClick = () => {
      if (ele.direct) {
        dispatch(logout());
        localStorage.setItem("OTC_V2_TOKEN", null);
        localStorage.clear();
        sessionStorage.clear();
        window.location = "/login";
      } else if (ele.link === "ra_date_change") {
        setRaChange(true);
      } else {
        navigate(ele.link);
      }
    };

    if (!navOpen) {
      return (
        <div
          className={`${Styles.collapsedItem} ${isActive ? Styles.collapsedItemActive : ""}`}
          onClick={handleClick}
        >
          <Icon style={{ height: "20px", width: "20px" }} />
          <span>{ele.name}</span>
        </div>
      );
    }

    return (
      <div
        className={`${Styles.entityListMain} ${showActive ? Styles.activeRoleContainer : ""}`}
        onMouseEnter={() => setActiveHover(ele.name)}
        onMouseLeave={() => setActiveHover("")}
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className={Styles.entityCollapsedConainter}>
          <div
            className={
              showActive ? Styles.activeViewNotif : Styles.inActiveViewNotif
            }
          />
          <Icon style={{ height: "16px", width: "16px" }} />
          <div
            className={`${Styles.collapseRoleName} ${showActive ? Styles.activeRoleContainerText : ""}`}
          >
            {ele.name}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={Styles.sidebarMainContainer}>
      {raChange && (
        <RaDateCHange open={raChange} handleClose={() => setRaChange(false)} />
      )}
      {navOpen ? (
        <div className={`display_flex_row ${Styles.topNameContainer}`}>
          <div className="display_flex_row_gap_8_only">
            <img width={20} height={20} src={sidebarCompanyIcon} alt="Icon" />
            <Tooltip
              title={
                <div className={Styles.tooltip}>{company?.companyName}</div>
              }
              arrow
              placement="right"
            >
              <span className={Styles.companyName}>
                {company?.companyName || "Company Name"}
              </span>
            </Tooltip>
          </div>
          <img
            width={18}
            height={18}
            src={panelClose}
            alt="Close"
            onClick={onNavSwitch}
            className="cursor_pointer"
            style={{ cursor: "pointer" }}
          />
        </div>
      ) : (
        <div className={Styles.topNameContainerCollapsed}>
          <img
            width={18}
            height={18}
            src={panelClose}
            alt="Open"
            onClick={onNavSwitch}
            className="cursor_pointer"
            style={{ transform: "rotate(180deg)", cursor: "pointer" }}
          />
          <img width={24} height={24} src={sidebarCompanyIcon} alt="Icon" />
          <Tooltip
            title={<div className={Styles.tooltip}>{company?.companyName}</div>}
            arrow
            placement="right"
          >
            <span className={Styles.companyNameCollapsed}>
              {company?.companyName || "Company"}
            </span>
          </Tooltip>
        </div>
      )}
      <div className={navOpen ? Styles.navBody : Styles.navBodyCollapsed}>
        <div
          onMouseLeave={scheduleClose}
          className={
            navOpen
              ? Styles.entityProductSectionDivided
              : Styles.collapsedSection
          }
        >
          {navOpen && <div className={Styles.elementHeading}>Entity</div>}
          <div>
            {roles?.map((ele) => (
              <EntityListMain key={ele.role} role={ele.role} ele={ele} />
            ))}
          </div>
        </div>
        {assignedProducts?.[0]?.firstChild?.length > 0 && (
          <div
            className={
              navOpen
                ? Styles.entityProductSectionDivided
                : Styles.collapsedSection
            }
            onMouseLeave={scheduleClose}
          >
            <div
              className={
                navOpen ? Styles.elementHeading : Styles.elementHeadingCollapsed
              }
            >
              {navOpen
                ? `Product - ${activeUser?.activeRole === "CONSUMER" ? "Buy" : activeUser?.activeRole === "GENERATOR" ? "Sell" : activeUser?.activeRole === "BANKING" ? "Banking" : ""}`
                : "Products"}
            </div>
            <div>
              {assignedProducts?.[0]?.firstChild?.map((ele) => (
                <ProductListMain key={ele.name} ele={ele} />
              ))}
            </div>
          </div>
        )}
        {commonProfile.length > 0 && (
          <div
            className={
              navOpen ? Styles.entityProductSection : Styles.collapsedSection
            }
          >
            {navOpen && <div className={Styles.elementHeading}>Profile</div>}
            <div>
              {commonProfile.map((ele) => (
                <ProfileListMain key={ele.name} ele={ele} />
              ))}
            </div>
          </div>
        )}
      </div>

      {(() => {
        if (!selectedSide || !flyoutPos) return null;
        const matchedRole = roles.find((r) => r.name === selectedSide);
        const matchedProduct = assignedProducts?.[0]?.firstChild?.find(
          (p) => p.name === selectedSide,
        );
        const hasEntityFlyout = matchedRole?.list?.length > 0;
        const hasProductFlyout = matchedProduct?.children?.length > 0;
        if (!hasEntityFlyout && !hasProductFlyout) return null;

        return ReactDOM.createPortal(
          <div
            className={Styles.entityRoleListMain}
            style={{
              position: "fixed",
              top: flyoutPos.top,
              left: flyoutPos.left + 4,
            }}
            onMouseEnter={cancelClose}
            onMouseLeave={scheduleClose}
          >
            {hasEntityFlyout && (
              <>
                <div className={Styles.entityHeading}>
                  {selectedSide?.toUpperCase()}
                </div>
                <EntityList
                  list={matchedRole.list}
                  selectedSide={selectedSide}
                />
              </>
            )}
            {hasProductFlyout &&
              matchedProduct.children.map((child) => {
                const [childPath, childQuery] = (child.link || "").split("?");
                const isChildActive =
                  location.pathname === childPath &&
                  (!childQuery ||
                    new URLSearchParams(location.search).get("type") ===
                      new URLSearchParams(childQuery).get("type"));
                const isChildHovered = hoverEntity === child.name;
                const showChildActive = isChildActive || isChildHovered;
                return (
                  <div
                    key={child.name}
                    className={Styles.entitySelfSelection}
                    onMouseEnter={() => handlesetHoverEntity(child.name)}
                    onMouseLeave={() => handlesetHoverEntity("")}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedSide("");
                      setFlyoutPos(null);
                      navigate(child.link);
                    }}
                  >
                    <div
                      className={
                        showChildActive
                          ? Styles.activeViewNotif
                          : Styles.inActiveViewNotif
                      }
                    />
                    <div
                      className={
                        showChildActive ? Styles.activeViewTextEntity : ""
                      }
                    >
                      {child.name}
                    </div>
                  </div>
                );
              })}
          </div>,
          document.body,
        );
      })()}
    </div>
  );
};

export default SideNavBar;
